import { useShallow } from "zustand/react/shallow";

import { Box, Link, Alert, Button, Typography } from "@mui/material";

import { userModel } from "src/store/userModel";

export const NoSubscriptionView = () => {
    const {subscription} = userModel(useShallow(state => state)) 
    
    if (subscription) {
        return null
    }

  return (
    <Box>
        <Alert severity="warning" action={
            <Button href="/pricing" target="_blank">
                Subscribe for more features.
            </Button>
        }>
            <Typography variant="body1" color="text.secondary">
            You are not subscribed to any plan. You account is limited to certain features.
            Learn more about our pricing plans <Link href="/pricing" target="_blank" fontWeight="bold">here</Link>.
            </Typography>
        </Alert>  
    </Box>
  );
};